// assets
import { LoginOutlined, ProfileOutlined, CompassOutlined, DatabaseOutlined, AuditOutlined, DollarOutlined, LikeOutlined } from '@ant-design/icons';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import TourIcon from '@mui/icons-material/Tour';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { ReactComponent as userManagement } from '../../icons/school 1.svg';
import { ReactComponent as accessManagement } from '../../icons/lock 1.svg';
import { ReactComponent as attendance } from '../../icons/fingerprint-scan 1.svg';
import { ReactComponent as order } from '../../icons/7409217_bill_cart_ecommerce_icon 1.svg';
import { ReactComponent as set } from '../../icons/8674892_ic_fluent_layer_regular_icon 1.svg';
import { ReactComponent as product } from '../../icons/5-star-product-quality 1.svg';
import { ReactComponent as routePlan } from '../../icons/6811927_direction_gps_location_map_navigation_icon 1.svg';
import { ReactComponent as collection } from '../../icons/budget 1.svg';
import { ReactComponent as specimen } from '../../icons/split-arrow 1.svg';
import { ReactComponent as visit } from '../../icons/Frame 34849.svg';
import { ReactComponent as party } from '../../icons/7239005_basic_add_new_create_plus_icon 1.svg';
import { ReactComponent as lead } from '../../icons/list (1) 1.svg';
import { Notes } from '@mui/icons-material';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RouteIcon from '@mui/icons-material/Route';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CategoryIcon from '@mui/icons-material/Category';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessIcon from '@mui/icons-material/Business';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ScienceIcon from '@mui/icons-material/Science';
import ReplayIcon from '@mui/icons-material/Replay';
import SettingsIcon from '@mui/icons-material/Settings';
import userManagementIcon from "../../icons/sidebar/userManagementIcon.svg"
import roleManagementIcon from "../../icons/sidebar/roleManagementIcon.svg"
import attendanceManagementIcon from "../../icons/sidebar/attendanceManagementIcon.svg"
import routeManagementIcon from "../../icons/sidebar/routeManagementIcon.svg"
import reportCentralIcon from "../../icons/sidebar/reportCentral.svg"
import accessManagementIcon from "../../icons/sidebar/accessManagement.svg"
import visitManagementIcon from "../../icons/sidebar/visitManagementIcon.svg"
import productManagementIcon from "../../icons/sidebar/productManagementIcon.svg"
import partyManagementIcon from "../../icons/sidebar/partyManagementIcon.svg"
import partyMergeIcon from "../../icons/sidebar/Merge.svg"
import faqIc from "../../icons/sidebar/faq.svg"
import stockistManagementIcon from "../../icons/sidebar/stockistManagementIcon.svg"
import transportManagementIcon from "../../icons/sidebar/transportManagementIcon.svg"
import allowancesIcon from "../../icons/sidebar/allowances.svg"
import orderManagementIcon from "../../icons/sidebar/orderManagementIcon.svg"
import trackingManagementIcon from "../../icons/sidebar/trackingManagementIcon.svg"
import incentiveManagementIcon from "../../icons/sidebar/incentiveManagementIcon.svg"
import collectionManagementIcon from "../../icons/sidebar/collectionManagementIcon.svg"
import specimanManagementIcon from "../../icons/sidebar/specimanManagementIcon.svg"
import returnManagementIcon from "../../icons/sidebar/returnManagementIcon.svg"
import locationManagementIcon from "../../icons/sidebar/locationManagementIcon.svg"
import picklistIcon from "../../icons/sidebar/picklistIcon.svg"
import expensIcon from "../../icons/sidebar/expenseIcon.svg"
import SpecimenAllotmentIcon from "../../icons/sidebar/SpecimenAllotmentIcon.svg"
import userRequestIcon from "../../icons/sidebar/userRequestIcon.svg"
import lastLocationIcon from "../../icons/sidebar/lastLocationIcon.svg";
import MergeParty from '../../views/MergeParty';
import FAQ from '../../views/FAQ';
import AutomationLogs from '../../views/AutomationLogs/AutomationLogs';
import automationIcon from "../../icons/sidebar/automation.svg"
import olympiadRegistrationIcon from "../../icons/sidebar/olympiadRegistrationManagemment.svg"
import olympiadClubbingIcon from "../../icons/sidebar/medal.svg"
import couponIcon from "../../icons/sidebar/coupon.svg"
import ticketIcon from "../../icons/sidebar/ticket.svg"

// icons
const icons = {
  LoginOutlined,
  ProfileOutlined,
  AuditOutlined,
  DollarOutlined,
  LikeOutlined,
  DatabaseOutlined,
  CompassOutlined
};

const UsrManagement = () => <img src={userManagementIcon} alt="icon" />;
const RolManagement = () => <img src={roleManagementIcon} alt="icon" height={"20"} width={"20"} />;
const AttendManagement = () => <img src={attendanceManagementIcon} alt="icon" height={"20"} width={"20"} />;
const RoutManagement = () => <img src={routeManagementIcon} alt="icon" height={"21"} width={"21"} />;
const ReportCentral = () => <img src={reportCentralIcon} alt="icon" height={"22"} width={"22"} />;
const AccessManagement = () => <img src={accessManagementIcon} alt="icon" height={"21"} width={"21"} />;
const lastLocationIconf = () => <img src={lastLocationIcon} alt="icon" height={"21"} width={"21"} />;
const VistManagement = () => <img src={visitManagementIcon} alt="icon" height={"21"} width={"21"} />;
const Allowances = () => <img src={allowancesIcon} alt="icon" height={"21"} width={"21"} />;
const ProdManagement = () => <img src={productManagementIcon} alt="icon" height={"19"} width={"19"} />;
const PartManagement = () => <img src={partyManagementIcon} alt="icon" height={"22"} width={"22"} />;
const mergePartyIc = () => <img src={partyMergeIcon} alt="icon" height={"22"} width={"22"} />;
const faqIcon = () => <img src={faqIc} alt="icon" height={"22"} width={"22"} />;
const StocktManagement = () => <img src={stockistManagementIcon} alt="icon" height={"21"} width={"21"} />;
const TransManagement = () => <img src={transportManagementIcon} alt="icon" height={"21"} width={"21"} />;
const OrdrManagement = () => <img src={orderManagementIcon} alt="icon" height={"21"} width={"21"} />;
const OrdrtrackdrManagement = () => <img src={trackingManagementIcon} alt="icon" height={"21"} width={"21"} />;
const IncentvManagement = () => <img src={incentiveManagementIcon} alt="icon" height={"21"} width={"21"} />;
const CollectManagement = () => <img src={collectionManagementIcon} alt="icon" height={"20"} width={"20"} />;
const SpecimnManagement = () => <img src={specimanManagementIcon} alt="icon" height={"20"} width={"20"} />;
const RetrnManagement = () => <img src={returnManagementIcon} alt="icon" height={"21"} width={"21"} />;
const LoctonManagement = () => <img src={userRequestIcon} alt="icon" height={"21"} width={"21"} />;
const pikIcon = () => <img src={picklistIcon} alt="icon" height={"21"} width={"21"} />;
const expenseIcon = () => <img src={expensIcon} alt="icon" height={"21"} width={"21"}></img>
const SpecimenAllotment = () => <img src={SpecimenAllotmentIcon} alt="icon" height={"21"} width={"21"}></img>
const automationIcon1 = () => <img src={automationIcon} alt="icon" height={"21"} width={"21"}></img>
const olympiadRegistration1 = () => <img src={olympiadRegistrationIcon} alt="icon" height={"21"} width={"21"}></img>
const olympiadClubbing1 = () => <img src={olympiadClubbingIcon} alt="icon" height={"21"} width={"21"}></img>
const couponManagement = () => <img src={couponIcon} alt="icon" height={"21"} width={"21"}></img>
const ticketManagement = () => <img src={ticketIcon} alt="icon" height={"21"} width={"21"}></img>
// rs sidebar icons
// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'authentication',
  title: 'Modules',
  type: 'group',
  children: [
    {
      id: 'usermanagement',
      title: 'User Management',
      type: 'item',
      url: '/usermanagement',
      icon: UsrManagement,
      target: true
    },
    {
      id: 'locationManagement',
      title: 'User Requests',
      type: 'item',
      url: '/locationManagement',
      icon: LoctonManagement,
      target: true
    },
    {
      id: 'rolemanagement',
      title: 'Role Management',
      type: 'item',
      url: '/rolemanagement',
      icon: RolManagement,
      target: true
    },
     {
      id: 'access-management',
      title: 'Access Management',
      type: 'item',
      url: '/accessManagement',
      icon: AccessManagement,
      target: true
    },
    {
      id: 'attendancemanagement',
      title: 'Attendance Management',
      type: 'item',
      url: '/attendancemanagement',
      icon: AttendManagement,
      target: true
    },
    {
      id: 'route-plan',
      title: 'Route Plan Management',
      type: 'item',
      url: '/routeplanManagement',
      icon: RoutManagement,
      target: true
    },
   
    // {
    //   id: 'last-location',
    //   type: 'item',
    //   url: '/lastLocation',
    //   icon: RoutManagement,
    //   target: true
    // },
  
    {
      id: 'visitmanagement',
      title: 'Visit Management',
      type: 'item',
      url: '/visitmanagement',
      icon: VistManagement,
      target: true
    },
    {
      id: 'allowances',
      title: 'Allowances',
      type: 'item',
      url: '/allowances',
      icon: Allowances,
      target: true
    },

    {
      id: 'Expense',
      title: 'Expense Management',
      type: 'item',
      url: '/expenseManagement',
      icon: expenseIcon,
      target: true
    },
     {
      id: 'olympiad-registration',
      title: 'Olympiad Registration',
      type: 'item',
      url: '/olympiadRegistration',
      icon: olympiadRegistration1,
      target: true
    },
     {
      id: 'olympiad-clubbing',
      title: 'Olympiad Summary',
      type: 'item',
      url: '/olympiadSummary',
      icon: olympiadClubbing1,
      target: true
    },
    //  {
    //   id: 'Coupon Management',
    //   title: 'Coupon Management',
    //   type: 'item',
    //   url: '/couponManagement',
    //   icon: couponManagement,
    //   target: true
    // },
    {
      id: 'product',
      title: 'Product Management',
      type: 'item',
      url: '/productManagement',
      icon: ProdManagement,
      target: true
    },
    // {
    //   id: 'set',
    //   title: 'Set Management',
    //   type: 'item',
    //   url: '/setManagement',
    //   icon: set,
    //   target: true
    // },
    {
      id: 'partymanagement',
      title: 'Party Management',
      type: 'item',
      url: '/partymanagement',
      icon: PartManagement,
      target: true
    },
     {
      id: 'mergeparty',
      title: 'Merge Party',
      type: 'item',
      url: '/mergeparty',
      icon: mergePartyIc,
      target: true
    },
    {
      id: 'stockistmanagement',
      title: 'Stockist Management',
      type: 'item',
      url: '/stockistmanagement',
      icon: StocktManagement,
      target: true
    },
    {
      id: 'Transporter',
      title: 'Transporter Management',
      type: 'item',
      url: '/transporterManagement',
      icon: TransManagement,
      target: true
    },
     {
      id: 'bookingConfirmation',
      title: 'Booking Confirmation',
      type: 'item',
      url: '/bookingConfirmation',
      icon: SpecimnManagement,
      target: true
    },
    {
      id: 'ordermanagement',
      title: 'Order Management',
      type: 'item',
      url: '/ordermanagement',
      icon: OrdrManagement,
      target: true
    },
      {
      id: 'specimen',
      title: 'Specimen Management',
      type: 'item',
      url: '/specimenManagement',
      icon: SpecimnManagement,
      target: true
    },
       {
      id: 'specimen Allotment',
      title: 'Specimen Allotment',
      type: 'item',
      url: '/specimenAllotment',
      // icon:  icons.DatabaseOutlined,
      icon:SpecimenAllotment,
      target: true
    },
    {
      id: '/orderTracking',
      title: 'Order Tracking',
      type: 'item',
      url: '/orderTracking',
      icon: OrdrtrackdrManagement,
      target: true
    },
    {
      id: 'last-location',
      title: 'Last Location',
      type: 'item',
      url: '/lastLocation',
      icon: lastLocationIconf,
      target: true
    },
    {
      id: '/:id',
      title: 'Consent Details',
      type: 'item',
      url: '/:id',
      // icon: icons.CompassOutlined,
      target: true
    },
    {
      id: 'incentivemanagement',
      title: 'Incentive Management',
      type: 'item',
      // url: '/incentivemanagement',
      icon: IncentvManagement,
      // target: true
    },
    {
      id: 'collection',
      title: 'Collection Management',
      type: 'item',
      // url: '/collectionManagement',
      icon: CollectManagement,
      // target: true
    },
    // {
    //   id: 'Lead',
    //   title: 'Lead Management',
    //   type: 'item',
    //   url: '/leadManagement',
    //   icon: lead,
    //   target: true
    // },

    // {
    //   id: 'Forecast',
    //   title: 'Forecast Report',
    //   type: 'item',
    //   url: '/forecastReport',
    //   icon: SummarizeOutlinedIcon,
    //   target: true
    // },
    // {
    //   id: 'Financial',
    //   title: 'Financial Report',
    //   type: 'item',
    //   url: '/financialReport',
    //   icon: SummarizeOutlinedIcon,
    //   target: true
    // },
    // {
    //   id: 'Pipeline',
    //   title: 'Pipeline Report',
    //   type: 'item',
    //   url: '/pipelineReport',
    //   icon: SummarizeOutlinedIcon,
    //   target: true
    // },
    {
      id: 'returnReason',
      title: 'Return Reason Report',
      type: 'item',
      // url: '/returnReasonReport',
      icon: RetrnManagement,
      // target: true
    },
    {
      id: 'returnOrderLineItemReport',
      title: 'Return Order Line Item Report',
      type: 'item',
      url: '/returnOrderLineItemReport',
      icon: SummarizeOutlinedIcon,
      target: true
    },
    // {
    //   id: 'Attendance',
    //   title: 'Attendance Report',
    //   type: 'item',
    //   url: '/attendanceReport',
    //   icon: icons.AuditOutlined,
    //   target: true
    // },
    

    {
      id: 'register',
      title: 'Register',
      type: 'item',
      url: '/register',
      icon: icons.ProfileOutlined,
      target: true
    },
    // {
    //   id: 'Audit Logs',
    //   title: 'Audit Logs',
    //   type: 'item',
    //   url: '/auditLogs',
    //   icon: Notes,
    //   target: true
    // },

    // {
    //   id: 'Total Time Worked Report',
    //   title: 'TotalTimeWorkedReport',
    //   type: 'item',
    //   url: '/TotalTimeWorkedReport',
    //   icon: Notes,
    //   target: true
    // },

    //        {
    //         id: '/Work Time School Distributor',
    //         title: 'Work Time School Distributor',
    //         type: 'item',
    //         url: '/workTimeSchoolDistributor',
    //         icon: Notes,
    //         target: true


    //        },
    //  { id: '/partyUpdateApproval',
    //  title: 'Party Update Approval',
    //  type: 'item',
    //  url: '/partyUpdateApproval',
    //  icon: icons.LikeOutlined,
    //  target: true



    //            // hideNavBar:true
    //        },

    //  {
    //   id: '/specimenAllotment',
    //   title: 'Specimen Allotment',
    //   type: 'item',
    //   url: '/specimenAllotment',
    //   icon: icons.DatabaseOutlined,
    //   target: true



    //  },
    {
      id: '/returnOrder',
      title: 'Returned Order',
      type: 'item',
      url: '/returnOrder',
      icon: Notes,
      target: true


      // hideNavBar:true
    },

 {
      id: 'Notification-Central',
      title: 'Notification Central',
      type: 'item',
      url: '/NotificationCentral',
      icon: faqIcon,
      target: true
    },
     {
      id: 'report-central',
      title: 'Report Central',
      type: 'item',
      url: '/reportcentral',
      icon: ReportCentral,
      target: true
    },
    {
      id: 'Picklist',
      title: 'Configuration',
      type: 'item',
      url: '/picklist',
      icon: pikIcon,
      target: true
    },
    {
      id: 'automation-logs',
      title: 'Automation Logs',
      type: 'item',
      url: '/automationLogs',
      icon: automationIcon1,
      target: true
    },
     {
      id: 'ticket-management',
      title: 'Ticket Management',
      type: 'item',
      url: '/ticketManagement',
      icon: ticketManagement,
      target: true
    },
     {
      id: 'FAQ',
      title: 'FAQ',
      type: 'item',
      url: '/FAQ',
      icon: faqIcon,
      target: true
    },
  ]
};

export default pages;
